var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"set":(_vm.strength = _vm.humanFilterStrength(_vm.score))}},[_c('div',{class:[
      'human-filters-score',
      { 'no-opacity': _vm.white_bg, 'bg-white': _vm.white_bg },
      `text-${_vm.strength.color}`,
    ],style:({
      backgroundColor: `rgba(${_vm.strength.hexColor.r}, ${_vm.strength.hexColor.g}, ${_vm.strength.hexColor.b}, 0.1)`,
    })},[_c('div',{class:['label', _vm.strength.color]},[_vm._v(_vm._s(_vm.score))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }